import { limitMessage } from "./limitMessage";

const convertMonetaryToNumber = (monetaryValue) => {
  if (!monetaryValue || typeof monetaryValue !== 'string') return 0;

  return parseFloat(
    monetaryValue
      .replace(/R\$\s?/g, '')
      .replace(/\./g, '')
      .replace(',', '.')
  ) || 0;
};

const selectAnswerOptionByRange = (answerOptions, answerValue) => {
  if (!answerOptions || !answerValue) return null;

  const numericValue = parseFloat(answerValue);

  const sortedOptions = answerOptions
    .filter(option => option.dsAnswerOption)
    .map(option => ({
      ...option,
      numericValue: convertMonetaryToNumber(option.dsAnswerOption)
    }))
    .filter(option => !isNaN(option.numericValue))
    .sort((a, b) => a.numericValue - b.numericValue);

  const selectedOption = sortedOptions.find(option => option.numericValue >= numericValue);
  return selectedOption || null;
};

export const handleQuestionsInitialAdjustments = (
  questionnaire,
  setPeriodicityText,
  operation,
  back
) => {
  return questionnaire.map(question => {
    if (question.idQuestion === 676) {
      const { idAnswerOption } = question;
      if (idAnswerOption === 4599) {
        setPeriodicityText(questionnaire.find(q => q.idQuestion === 1200)?.dsQuestion || '-');
      } else {
        setPeriodicityText(questionnaire.find(q => q.idQuestion === 1199)?.dsQuestion || '-');
      }
    }

    if (question.idQuestion === 682) {
      let limitQuestions = questionnaire.filter(qst => qst.idQuestion === 682);
      let isRequired = true;
      for (let i = 0; i < limitQuestions.length; i++) {
        if (limitQuestions[i].answer) {
          isRequired = false;
          break;
        }
      }

      if (question.idQuestion === 682) {
        const limitTypeQuestion = question?.childrenQuestions.find(v => v.idQuestion === 1391);
        if (limitTypeQuestion && question.answer) {
          if (+question.answer <= 10000000) {
            limitTypeQuestion.idAnswerOption = 6813
          } else {
            limitTypeQuestion.idAnswerOption = 6814
          }
        }
      }

      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 682) {
          qst.behaviorObject.isRequired = isRequired;
        }
        return qst;
      })
    }

    if (question.idQuestion === 1250) {
      let limitQuestions = questionnaire.filter(qst => qst.idQuestion === 1250);
      let isRequired = true;
      for (let i = 0; i < limitQuestions.length; i++) {

        if (limitQuestions[i].answer) {
          isRequired = false;
          break;
        }
      }

      // Verifica se há answerOptions e answer para selecionar automaticamente
      if (question.answer && question.answerOptions) {
        const selectedOption = selectAnswerOptionByRange(question.answerOptions, question.answer);
        if (selectedOption) {
          question.idAnswerOption = selectedOption.idAnswerOption;
        }
      }

      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 1250) {
          qst.behaviorObject.isRequired = isRequired;
        }
        return qst;
      })
    }

    if (question.idQuestion === 1193) {
      const qst = questionnaire.find(v => v.idQuestion === 675);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4597;
    }

    if (question.idQuestion === 1194 || question.idQuestion === 1195) {
      const qst = questionnaire.find(v => v.idQuestion === 679);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4604;
      question.behaviorObject.isRequired = idAnswerOption === 4604;
      if (idAnswerOption === 4605) {
        question.answer = ""
        question.idAnswerOption = null
      }
    }

    if (question.idQuestion === 1174) {
      const qst = questionnaire.find(v => v.idQuestion === 680);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4606;
      if (idAnswerOption === 4607) {
        question.idAnswerOption = null
        question.answer = ""
      }
    }

    if (question.idQuestion === 1190) {
      const hasAnswer = question.answer?.length;
      question.childrenQuestions = question.childrenQuestions?.map(v => {
        v.behaviorObject.isRequired = !!hasAnswer;
        return v
      });
    }

    if (question.idQuestion === 1197) {
      const qst = questionnaire.find(v => v.idQuestion === 1196);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6119;
      if (idAnswerOption === 6120) {
        question.idAnswerOption = null
        question.answer = ""
      }
    }

    if (question.idQuestion === 712) {
      const qst = questionnaire.find(v => v.idQuestion === 673);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4691;
    }

    if (question.idQuestion === 1177) {
      const qst = questionnaire.find(v => v.idQuestion === 681);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4608;
    }

    if (question.idQuestion === 1175) {
      const qst = questionnaire.find(v => v.idQuestion === 1174);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6073;
    }

    // Novas questions - produto 48
    if (question.idQuestion === 1246) {
      const qst = questionnaire.find(v => v.idQuestion === 1245);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6236;
    }

    if (question.idQuestion === 1248) {
      const qst = questionnaire.find(v => v.idQuestion === 1247);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6238;
    }

    if ((question.idQuestion === 1236 || question.idQuestion === 1237) && (operation && operation?.idDomainStatus === 1) && !back) {
      question.visibleQuestion = false;
    }

    if (question.idQuestion === 1252) {
      const qst = questionnaire.find(v => v.idQuestion === 673);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 4691;
    }

    if (question.idQuestion === 1389) {
      const qst = questionnaire.find(v => v.idQuestion === 1244);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6234;
      question.behaviorObject.additionalInfo = question.idAnswerOption === 6812 ? "As informações devem corresponder ao " +
        "total da atividade do Segurado - e não somente ao contrato específico" : "";
    }

    if (question.idQuestion === 1250) {
      const qst1237 = questionnaire.find(v => v.idQuestion === 1237);
      const qst1236 = questionnaire.find(v => v.idQuestion === 1236);

      //const findMessage = limitMessage.find(v => v.question1237 === `${qst1237?.idAnswerOption}` && v.question1236 === `${qst1236?.idAnswerOption}`)
      //question.behaviorObject.additionalInfo = `${findMessage?.mensagem || ''}`;
    }

    handleQuestionRefusedAndWarning(question, questionnaire);

    return question;
  })
}

export const handleQuestionChange = (
  question,
  value,
  filteredQuestionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
  questionnaire,
  setPeriodicityText,
  setCurrentModality,
  setFieldError
) => {
  let saveFilteredQuestionnaire = false;

  if (question.idQuestion === 676) {
    const { idAnswerOption } = value;
    if (idAnswerOption === 4599) {
      setPeriodicityText(questionnaire.find(q => q.idQuestion === 1200)?.dsQuestion || '-')
    } else {
      setPeriodicityText(questionnaire.find(q => q.idQuestion === 1199)?.dsQuestion || '-')
    }
  }

  if (question.idQuestion === 1237 || question.idQuestion === 1236) {
    saveFilteredQuestionnaire = true;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1250) {
        const qst1237 = filteredQuestionnaire.find(v => v.idQuestion === 1237);
        const qst1236 = filteredQuestionnaire.find(v => v.idQuestion === 1236);

        //const findMessage = limitMessage.find(v => v.question1237 === `${qst1237?.idAnswerOption}` && v.question1236 === `${qst1236?.idAnswerOption}`)
        //qst.behaviorObject.additionalInfo = `${findMessage?.mensagem || ''}`;
      }
      return qst;
    })
  }

  if (question.idQuestion === 682) {
    saveFilteredQuestionnaire = true;

    let limitQuestions = filteredQuestionnaire.filter(qst => qst.idQuestion === 682);
    let isRequired = true;
    for (let i = 0; i < limitQuestions.length; i++) {
      if (limitQuestions[i].answer) {
        isRequired = false;
      }
    }

    const limitTypeQuestion = question?.childrenQuestions.find(v => v.idQuestion === 1391)
    if (limitTypeQuestion && value) {
      if (+value <= 10000000) {
        limitTypeQuestion.idAnswerOption = 6813
      } else {
        limitTypeQuestion.idAnswerOption = 6814
      }
    }

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 682) {
        qst.behaviorObject.isRequired = isRequired;
        if (!isRequired) setFieldError && setFieldError(qst.key, null);
        if (qst.answer) {
          if (qst.answer < qst.behaviorObject.fieldMinValue) {
            qst.answer = qst.behaviorObject.fieldMinValue;
          } else if (qst.answer > qst.behaviorObject.fieldMaxValue) {
            qst.answer = qst.behaviorObject.fieldMaxValue;
          }
        }
      }
      return qst;
    })
  }


  if (question.idQuestion === 1250) {
    saveFilteredQuestionnaire = true;

    let limitQuestions = filteredQuestionnaire.filter(qst => qst.idQuestion === 1250);
    let isRequired = true;
    for (let i = 0; i < limitQuestions.length; i++) {
      if (limitQuestions[i].answer) {
        isRequired = false;
      }
    }

    // Verifica se há answerOptions e value para selecionar automaticamente
    if (value && question.answerOptions) {
      const selectedOption = selectAnswerOptionByRange(question.answerOptions, value);
      if (selectedOption) {
        question.idAnswerOption = selectedOption.idAnswerOption;
      }
    }

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1250) {
        qst.behaviorObject.isRequired = isRequired;
        if (!isRequired) setFieldError && setFieldError(qst.key, null);
        if (qst.answer) {
          if (qst.answer < qst.behaviorObject.fieldMinValue) {
            qst.answer = qst.behaviorObject.fieldMinValue;
          } else if (qst.answer > qst.behaviorObject.fieldMaxValue) {
            qst.answer = qst.behaviorObject.fieldMaxValue;
          }
        }

        const selectedOption = selectAnswerOptionByRange(qst.answerOptions, qst.answer);
        if (selectedOption) {
          qst.idAnswerOption = selectedOption.idAnswerOption;
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 675) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1193) {
        qst.visibleQuestion = idAnswerOption === 4597;
      }
      return qst;
    })
  }

  if (question.idQuestion === 679) {
    saveFilteredQuestionnaire = true;

    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1194, 1195].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 4604;
        qst.behaviorObject.isRequired = idAnswerOption === 4604;
        if (idAnswerOption === 4605) {
          qst.answer = "";
          qst.idAnswerOption = null
        }
      }

      return qst;
    })
  }

  if (question.idQuestion === 680) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1174) {
        qst.visibleQuestion = idAnswerOption === 4606;
        if (idAnswerOption === 4607) {
          qst.idAnswerOption = null
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1190) {
    saveFilteredQuestionnaire = true;

    const questonIndex = parseFloat(filteredQuestionnaire.find(qst => qst.idQuestion === 1190).answer || 0)
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1191) {
        if (questonIndex > 0) {
          qst.behaviorObject.isRequired = true
        } else {
          qst.behaviorObject.isRequired = false
        }
      }

      if (qst.idQuestion === 1192) {
        if (questonIndex > 0) {
          qst.behaviorObject.isRequired = true
        } else {
          qst.behaviorObject.isRequired = false
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1196) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1197) {
        qst.visibleQuestion = idAnswerOption === 6119;
        if (idAnswerOption === 6120) {
          qst.idAnswerOption = null;
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 673) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 712) {
        qst.visibleQuestion = idAnswerOption === 4691;
      }

      if (qst.idQuestion === 1252) {
        qst.visibleQuestion = idAnswerOption === 4691;
      }

      return qst;
    })
  }

  if (question.idQuestion === 680) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1174) {
        qst.visibleQuestion = idAnswerOption === 4606;
      }
      if (qst.idQuestion === 1175 && idAnswerOption === 4607) {
        qst.visibleQuestion = idAnswerOption === 4606;
        if (idAnswerOption === 4607) {
          qst.idAnswerOption = null;
          qst.answer = ""
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1174) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1175) {
        qst.visibleQuestion = idAnswerOption === 6073;
        if (idAnswerOption === 6074) {
          qst.answer = "";
          qst.idAnswerOption = null;
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 681) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1177) {
        qst.visibleQuestion = idAnswerOption === 4608;
        if (idAnswerOption === 4609) {
          qst.answer = "";
          qst.idAnswerOption = null;
        }
      }
      return qst;
    })
  }

  if (question.idQuestion === 1236) {
    handleTypeModalityChange(question, value, setCurrentModality)
  }

  if (question.idQuestion === 1244) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1389) {
        qst.visibleQuestion = idAnswerOption === 6234;
      }
      return qst;
    })
  }

  if (question.idQuestion === 1245) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1246) {
        qst.visibleQuestion = idAnswerOption === 6236;
        qst.behaviorObject.isRequired = idAnswerOption === 6236;
      }
      return qst;
    })
  }

  if (question.idQuestion === 1247) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1248) {
        qst.visibleQuestion = idAnswerOption === 6238;
        qst.behaviorObject.isRequired = idAnswerOption === 6238;
      }
      return qst;
    })
  }

  if ([1246, 1248].includes(question.idQuestion)) {
    const qstRoot = question.idQuestion === 1246 ? 1245 : 1247;
    const { childrenQuestions } = questionnaire.find(v => v.idQuestion === qstRoot);
    const qstChildQuestion = childrenQuestions.find(v => v.idQuestion === question.idQuestion);
    qstChildQuestion.answer = value;
  }

  if (question.idQuestion === 1389) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    question.behaviorObject.additionalInfo = idAnswerOption === 6812 ? "As informações devem corresponder ao total da " +
      "atividade do Segurado - e não somente ao contrato específico" : "";
  }

  if (saveFilteredQuestionnaire) setFilteredQuestionnaire(filteredQuestionnaire);
}


const handleTypeModalityChange = (question, value, setCurrentModality) => {
  const answerOption = question.answerOptions.find(answerOption => answerOption.idAnswerOption === value.idAnswerOption);
  const { resultProductPlan } = answerOption?.behaviorObject || {};

  if (resultProductPlan) {
    setCurrentModality && setCurrentModality(resultProductPlan);
  }
}


export const handleRequestSerproCnpj = async (rootQuestion, data, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
  try {
    filteredQuestionnaire = filteredQuestionnaire.map(question => {
      if (rootQuestion.idQuestion === 658 && question.idQuestion === 660) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 658 && question.idQuestion === 658) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1235) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1234) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1234 && question.idQuestion === 1307) {
        const answerOptionDeclined = question.answerOptions.find(option => option.idAnswerOption === 6605);
        question.idAnswerOption = answerOptionDeclined?.idAnswerOption;
        question.answer = answerOptionDeclined?.dsAnswerOption;
        setFieldValue && setFieldValue(question.key, question);

        return ({ ...question, answer: answerOptionDeclined.dsAnswerOption, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1235 && question.idQuestion === 1307) {
        const answerOptionDeclined = question.answerOptions.find(option => option.idAnswerOption === 6605);
        question.idAnswerOption = answerOptionDeclined?.idAnswerOption;
        question.answer = answerOptionDeclined?.dsAnswerOption;
        setFieldValue && setFieldValue(question.key, question);

        return ({ ...question, answer: answerOptionDeclined.dsAnswerOption, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1225 && question.idQuestion === 1226) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 1225 && question.idQuestion === 1225) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 661 && question.idQuestion === 662) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 661 && question.idQuestion === 661) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 663 && question.idQuestion === 664) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        return ({ ...question, answer: data.nomeEmpresarial, answerJson: undefined });
      }

      if (rootQuestion.idQuestion === 663 && question.idQuestion === 663) {
        setFieldValue && setFieldValue(question.key, data.ni);
        return ({ ...question, answer: data.ni, answerJson: undefined });
      }

      return question;
    })

    setFilteredQuestionnaire(filteredQuestionnaire);
  } catch (e) {
    console.log('handleRequestSerproCnpj error', e)
  }
};


export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires) => {
  mc.error('Por favor, preencha todos os campos obrigatórios para prosseguir.')
  const allQuestions = questionnaire;
  groupQuestionnaires.map(questionnaire => questionnaire.map(question => allQuestions.push(question)));

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    e.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);
      if (question) mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
      if (e.message === "Email inválido") formikRef.current.setFieldError(question.key, `* Email inválido`);
      else formikRef.current.setFieldError(question.key, `* Campo Obrigatório`);
      if (!firstErrorKey) firstErrorKey = question.key;
    })

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}


export const sectionIsVisible = (sectionName, questionnaire) => {
  return questionnaire
    .some(question => question?.behaviorObject?.sectionName === sectionName)
}


const getQuestionIsDisabled = (question, operation, isBound) => {
  if (isBound) return true;
  return false;
}


export const groupMultipleFieldQuestions = (mainIdQuestion, questionnaire, operation, isBound) => {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  for (const mainQuestion of mainQuestions) {
    let group = []
    const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
    if (mainQuestionIndex) group.push(questionnaire[mainQuestionIndex]);
    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);
    mainQuestion.childrenQuestions.map(childQuestion => group.push(childQuestion));

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
    groupQuestions.push(group.map((question, index) => ({ ...question, key: null, disabled: getQuestionIsDisabled(question, operation, isBound) })));
  }

  return groupQuestions;
}


export const removeAnswersDuplicateSession = (questions) => {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map(question => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;
    return question;
  })
}

export const handleQuestionRefusedAndWarning = (question, questionnaire) => {
  let answerQuestion = question.answerOptions?.find(ansOpt => ansOpt.idAnswerOption === question.idAnswerOption);

  if (answerQuestion && [38, 40].includes(answerQuestion.idDomain) && question.idQuestionRoot) {
    questionnaire = questionnaire.map(qst => {
      if ([question.idQuestionRoot].includes(qst.idQuestion)) {
        if (answerQuestion.idDomain === 38) {
          qst.behaviorObject.isRefusedByHiddenQuestions = true;
        } else if (answerQuestion.idDomain === 40) {
          qst.behaviorObject.isWarningByHiddenQuestions = true;
        }
      }
      return qst;
    });
  }
}